import { EnvironmentProviders, Provider } from "@angular/core";
import {
    provideTransloco,
    provideTranslocoTranspiler,
    TRANSLOCO_INTERCEPTOR,
    TRANSLOCO_MISSING_HANDLER,
} from "@jsverse/transloco";
import { IntlMessageFormatTranspiler } from "./transloco-intl-transpiler";
import { TranslocoRootLoader } from "./transloco-loader";
import { PseudoInterceptor } from "./transloco-pseudo.interceptor";
import { ReportingMissingHandler } from "./reporting-missing-handler";

/** The app's root translation setup. Register it once, in the root injector. */
export function provideTranslation(): (Provider | EnvironmentProviders)[] {
    return [
        provideTransloco({
            // Production-safe baseline: English only. The pseudo language and the
            // dev i18n tooling are enabled at runtime from an APP_INITIALIZER when the
            // backend reports a Development environment (see initializeClientConfig).
            config: {
                availableLangs: ["en"],
                defaultLang: "en",
                fallbackLang: "en",
                reRenderOnLangChange: true,
                prodMode: true,
                missingHandler: { useFallbackTranslation: true },
            },
            loader: TranslocoRootLoader,
        }),
        // CSP-safe ICU transpiler (no unsafe-eval). See transloco-intl-transpiler.ts.
        provideTranslocoTranspiler(IntlMessageFormatTranspiler),
        { provide: TRANSLOCO_INTERCEPTOR, useClass: PseudoInterceptor },
        // Report untranslated keys to Sentry via I18nObservabilityService.
        { provide: TRANSLOCO_MISSING_HANDLER, useClass: ReportingMissingHandler },
    ];
}
